__turbopack_context__.v({
  "inputWrapper": "_7jgaqq_inputWrapper",
  "searchButton": "_7jgaqq_searchButton",
  "searchButtonLabel": "_7jgaqq_searchButtonLabel",
  "searchButtonLabelOpen": "_7jgaqq_searchButtonLabelOpen",
  "wrapper": "_7jgaqq_wrapper",
});
